import { useCallback } from 'react';
import { css } from '@emotion/react';
import { ProductCardCarousel } from '@core/shopping/components/ProductCardCarousel';
import { CARD_HEIGHT, CARD_MIN_WIDTH, } from '@core/shopping/components/ProductCardCarousel/ProductCardCarousel.styles';
import { useTrackProductCardClick } from '@core/widgets/tracking/useTrackProductCardClick';
import { useTrackProductCardImpression } from '@core/widgets/tracking/useTrackProductCardImpression';
import { PRODUCT_CARD_CAROUSEL_WRAPPER } from '@player/testIds';
/**
 * Thumbnail product card carousel component.
 * @param param0
 * @returns
 */
export const ThumbnailProductCardCarousel = ({ availableWidth, availableHeight, padding, video, isHidden }) => {
    /**
     * Product card click tracking
     */
    const trackProductCardClick = useTrackProductCardClick(video);
    const onCardClick = useCallback((event, product) => {
        trackProductCardClick(product);
    }, [trackProductCardClick]);
    /**
     * Product card impression tracking
     */
    const trackProductCardImpression = useTrackProductCardImpression(video);
    const onCardVisibilityChange = useCallback((isVisible, product) => {
        trackProductCardImpression(isVisible, product);
    }, [trackProductCardImpression]);
    return (<div css={css `
        position: absolute;
        z-index: 3;
        bottom: ${padding || 0}px;
        width: 100%;
        height: auto;
        zoom: ${(availableHeight || 0) / 5 / CARD_HEIGHT};

        opacity: ${isHidden ? 0 : 1};
        transition: opacity 0.3s;

        a,
        button {
          color: white;
        }

        --background: var(--player-shop-background);
        --border-radius: var(--thumbnail-border-radius);
      `} data-testid={PRODUCT_CARD_CAROUSEL_WRAPPER}>
      <ProductCardCarousel cardSizeOffset={video.products.length > 1 ? 20 : 0} compactSize={!!availableWidth && availableWidth < 2 * CARD_MIN_WIDTH} onCardClick={onCardClick} onCardVisibilityChange={onCardVisibilityChange} padding={padding} products={video.products} showCTA={false} showNavButtons={false}/>
    </div>);
};
